import { convertToSnakeCase } from './textos';

export const addNewOpt = (newArray) => {

  const mapValues = newArray.map(
    (item) => (
      item.value
        ? item 
        : { value: convertToSnakeCase(item.text), text: item.text } 
    )
  );

  return mapValues;
}


export const addUniqueNewOpt = (item) => {
  
  if( !item ) return null;

  const newItem = { value: convertToSnakeCase(item.text), text: item.text };
  return newItem;
}